<template>
  <div class="section bg-pink overflow-hidden">
    <div class="content">
      <div class="title-wrapper dark">
        <span>
          <h2 class="font-bad font-weight-bold"> Courses and Public Projects </h2>
        </span>
      </div>
      <b-container v-if="showProjectCards">
        
        <!--<b-row v-if="showProjectCards">-->
          <transition-group 
            tag="b-row" 
            mode="out-in"
            appear
            v-bind:css="false"
            v-on:before-enter="beforeEnter"
            v-on:enter="enter">
            <b-col cols="12" md="4"
              v-for="(project, i) in projects"
              v-bind:key="project.id"
              v-bind:data-index="i">
              <div class="card mason-card mx-auto"
                >
                <img 
                  :src="project.imgSrc" class="fluid card-img-top" 
                  :alt="project.title">
                <div class="card-title d-flex justify-content-between align-items-center">
                  <h5 class="text-left">
                    {{ project.title }}
                  </h5>
                  <div class="options ml-4 d-flex justify-content-end">
                    <a
                      v-if="project.links.linkedIn" 
                      :href="project.links.linkedIn" target="_blank" 
                      rel="" class="link-accent link-circle">
                      <i class="fab fa-linkedin-in" aria-hidden="true"></i>
                    </a>
                    <a
                    v-if="project.links.link" 
                    :href="project.links.link" target="_blank" 
                    rel="" class="link-accent link-circle ml-1">
                      <i class="fas fa-link" aria-hidden="true"></i>
                    </a>
                    <a
                    v-if="project.links.github" 
                    :href="project.links.github" target="_blank" 
                    rel="" class="link-accent link-circle ml-1">
                      <i class="fab fa-github-alt"
                      aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
                <div class="card-backdrop"></div>
              </div>
            </b-col>
          </transition-group>
        <!-- </b-row>-->
      
      </b-container>
    </div>
  </div>
</template>

<script>
  import Velocity from 'velocity-animate'
  export default {
    props: {
      showProjectCards: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        projects: [
          {
            id: 0,
            imgSrc: '/my-projects/linkedin/csharp.PNG',
            type: 'course',
            title: 'C# Esencial',
            subtitle: 'LinkedIn Learning',
            links: {
              linkedIn: 'https://www.linkedin.com/learning/c-sharp-esencial'
            }
          },
          {
            id: 1,
            imgSrc: '/my-projects/linkedin/csharp7.PNG',
            type: 'course',
            title: ' Novedades C# 7',
            subtitle: 'LinkedIn Learning',
            links: {
              linkedIn: 'https://www.linkedin.com/learning/novedades-c-sharp-7'
            }
          },
          {
            id: 2,
            imgSrc: '/my-projects/linkedin/learn-csharp.PNG',
            type: 'course',
            title: 'Aprende C#',
            subtitle: 'LinkedIn Learning',
            links: {
              linkedIn: 'https://www.linkedin.com/learning/aprende-c-sharp'
            }
          },
          {
            id: 3,
            imgSrc: '/my-projects/linkedin/ml-net.PNG',
            type: 'course',
            title: 'App Machine Learning con ML.NET',
            subtitle: 'LinkedIn Learning',
            links: {
              linkedIn: 'https://www.linkedin.com/learning/c-sharp-creacion-de-una-app-con-machine-learning'
            }
          },
          {
            id: 4,
            imgSrc: '/my-projects/linkedin/mvc5.PNG',
            type: 'course',
            title: 'ASP.NET MVC5 esencial',
            subtitle: 'LinkedIn Learning',
            links: {
              linkedIn: 'https://www.linkedin.com/learning/asp-dot-net-mvc-5-esencial'
            }
          },
          {
            id: 5,
            imgSrc: '/my-projects/linkedin/poo.PNG',
            type: 'course',
            title: 'C# Programacion Orientada a Objetos',
            subtitle: 'LinkedIn Learning',
            links: {
              linkedIn: 'https://www.linkedin.com/learning/asp-dot-net-mvc-5-esencial'
            }
          },
          {
            id: 6,
            imgSrc: '/my-projects/linkedin/relationalDB.PNG',
            type: 'course',
            title: 'Aprende diseño de base de datos relacionales',
            subtitle: 'LinkedIn Learning',
            links: {
              linkedIn: 'https://www.linkedin.com/learning/aprende-diseno-de-base-de-datos-relacionales'
            }
          },
          {
            id: 7,
            imgSrc: '/my-projects/linkedin/test-driven-dev.PNG',
            type: 'course',
            title: 'C#: Desarrollo Test Driven',
            subtitle: 'LinkedIn Learning',
            links: {
              linkedIn: 'https://www.linkedin.com/learning/c-sharp-desarrollo-test-driven'
            }
          },
          {
            id: 8,
            imgSrc: '/my-projects/linkedin/web-sql.PNG',
            type: 'course',
            title: 'C# avanzado: Creación de una aplicación web-SQL',
            subtitle: 'LinkedIn Learning',
            links: {
              linkedIn: 'https://www.linkedin.com/learning/c-sharp-avanzado-creacion-de-una-aplicacion-web-sql'
            }
          },
          {
            id: 9,
            imgSrc: '/my-projects/cf/bootstrap-intro.PNG',
            type: 'course',
            title: 'Introduccion a Bootstrap 4',
            subtitle: 'Codigo Facilito',
            links: {
              link: 'https://codigofacilito.com/cursos/bootstrap',
              github: 'https://github.com/noeleo25/micv'
            }
          },
          {
            id: 10,
            imgSrc: '/my-projects/cf/vue-proyecto.PNG',
            type: 'course',
            title: 'Creacion de un proyecto con Vue',
            subtitle: 'Codigo Facilito',
            links: {
              link: 'https://codigofacilito.com/cursos/vue-proyecto',
              github: 'https://github.com/noeleo25/game-of-thrones'
            }
          },
          {
            id: 11,
            imgSrc: '/my-projects/cf/bootstrap-intro.PNG',
            type: 'course',
            title: 'Bootstrap 4 Avanzado',
            subtitle: 'Codigo Facilito',
            links: {
              link: 'https://codigofacilito.com/cursos/bootstrap-avanzado',
              github: 'https://github.com/noeleo25/adopta-mascota'
            }
          },
          {
            id: 12,
            imgSrc: '/my-projects/cf/browser-ext.PNG',
            type: 'course',
            title: 'Crea una Extensión para Chrome',
            subtitle: 'Codigo Facilito',
            links: {
              link: 'https://codigofacilito.com/cursos/extension-chrome',
              github: 'https://github.com/noeleo25/browser-extension-codigofacilito'
            },
          },
          {
            id: 13,
            imgSrc: '/my-projects/web/diplus.PNG',
            type: 'website',
            title: 'Diplus Website',
            subtitle: 'Diplus',
            links: {
              link: 'https://diplus.tech'
            }
          },
          {
            id: 14,
            type: 'course',
            title: 'Servicios web con ASP.NET',
            imgSrc: '/my-projects/cf/wcf.jpg',
            links:{
              link: 'https://codigofacilito.com/cursos/servicios-web-net',
              github: 'https://github.com/noeleo25/webservice-wcf'
            }
          },
          {
            id: 15,
            type: 'course',
            title: 'Web API en .NET',
            imgSrc: '/my-projects/cf/web-api.PNG',
            links:{
              link: 'https://codigofacilito.com/cursos/web-api-net',
              github: 'https://github.com/noeleo25/webapi-example'
            }
          }
        ]
      }
    },
    methods: {
      beforeEnter: function (el) {
        el.style.opacity = 0
        el.style.height = 0
      },
      enter: function (el, done) {
        var delay = el.dataset.index * 500;
        setTimeout(function () {
          Velocity(
            el,
            { opacity: 1, height: '100%' },
            { duration: 500, complete: done }
          )
        }, delay)
      },
    },
  }
</script>

<style>
.content{
  height: inherit;
  /*background: pink;*/
}
.section-title{
  color: #F58F7C;
}
.movefrombottom-enter-active {
  animation: movefrombottom-in 2.5s;
}
.mason-card{
  max-width: 320px;
  margin-bottom: 1.75rem;
  -webkit-box-shadow: 0 7px 14px 0 rgba(0,0,0,.16);
  box-shadow: 0 7px 14px 0 rgba(0,0,0,.16);
  height: 240px;
  position: relative;
  border: none;
  overflow: hidden;
  transition: all 1s ease-in;
}
.mason-card >img{
  height: 100%;
  object-fit: cover;
  pointer-events: none;
}
.mason-card .card-title{
  position: absolute;
  bottom: -95px;
  padding: 1rem;
  background: #fff;
  width: 100%;
  transition: all 0.4s ease-in;
  display: block;
  margin-bottom: 0;
  z-index: 3;
}
.mason-card .card-title > h5{
  font-size: 16px;
  font-weight: bold;
}
.mason-card:hover .card-title{
  transform: translateY(-95px);
}
.mason-card:hover > .card-backdrop{
  opacity: 1;
}
.card-backdrop{
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.40);
  opacity: 0;
  transition: opacity 0.15s ease-in;
  z-index: 2;
}
@keyframes movefrombottom-in {
  0% {
    transform: translateY(200%);
  }
  100% {
    transform: translateY(0);
  }
}
</style>